// Frontend RBAC map — MUST mirror backend rbac.py PERMISSIONS.
// Eyes Çelik nihai rol yapısı: department_manager kaldırıldı.
const PERMS = {
    "masterdata.write": ["admin"],

    // PR — Yönetici + Satın Alma + Müdür + Mühendis + Depo
    "pr.create": ["admin", "purchasing_specialist", "purchasing_manager", "requester", "warehouse"],
    // PR onayı — Yönetici + Satın Alma + Müdür
    "pr.approve": ["admin", "purchasing_manager", "purchasing_specialist"],

    // RFQ + Quotation girme — Satın Alma + Yönetici (Müdür yalnız görüntüler)
    "rfq.create": ["admin", "purchasing_specialist"],
    "quotation.create": ["admin", "purchasing_specialist"],

    // PO — Satın Alma + Müdür + Yönetici
    "po.create": ["admin", "purchasing_manager", "purchasing_specialist"],
    "po.approve": ["admin", "purchasing_manager"],
    "po.send": ["admin", "purchasing_manager", "purchasing_specialist"],
    "po.cancel": ["admin", "purchasing_manager"],

    // Mal Kabul — Depo + Satın Alma + Yönetici
    "gr.create": ["admin", "warehouse", "purchasing_specialist"],

    // Fatura — Satın Alma + Yönetici (finance BC)
    "invoice.create": ["admin", "finance", "purchasing_specialist"],
    "invoice.approve": ["admin", "finance", "purchasing_specialist"],
    "invoice.reject": ["admin", "finance", "purchasing_specialist"],

    "config.write": ["admin"],
    "audit.read": ["admin", "auditor"],
    "attachment.upload": ["admin", "purchasing_specialist", "purchasing_manager",
                          "warehouse", "finance", "project_manager", "requester"],
    "attachment.delete": ["admin", "purchasing_manager", "finance"],

    "user.manage": ["admin"],
    "recycle.list": ["admin", "purchasing_manager", "finance", "auditor"],
    "recycle.restore": ["admin", "purchasing_manager", "finance"],
    "recycle.permanent": ["admin"],
};

export function can(user, perm) {
    if (!user || !user.role) return false;
    const allowed = PERMS[perm];
    if (!allowed) return false;
    return allowed.includes(user.role);
}

export function hasModule(user, mod) {
    if (!user) return false;
    if (user.role === "admin") return true;
    return !!(user.modules && user.modules[mod]);
}

// Turkish labels (Eyes Çelik nihai adlandırma)
export const ROLE_LABELS = {
    admin: "Yönetici",
    purchasing_manager: "Müdür",
    purchasing_specialist: "Satın Alma",
    warehouse: "Depo",
    finance: "Muhasebe",
    requester: "Mühendis / Talep Eden",
    project_manager: "Proje Yöneticisi",
    general_manager: "Genel Müdür",
    auditor: "Denetçi",
    hr_officer: "İK / İSG",
};

export const MODULE_LABELS = {
    purchasing: "Satın Alma",
    cash: "Kasa",
    hr: "İK / İSG",
};
